module.exports = __webpack_public_path__ + "img/1502452646.030c8385.jpg";